import { createContext, useContext } from "react";

import { DistributorOrderingCtx } from "./OrderingCtx";

export type TDistributorOrderingContext = {
  orderingCtxId: string;
  setOrderingCtxId: (id: string | null) => void;
  orderingCtx: DistributorOrderingCtx;
  orderingCtxOptions: DistributorOrderingCtx[];
};

export const DistributorOrderingContext =
  createContext<TDistributorOrderingContext | null>(null);

export const useDistributorOrderingContext = () => {
  const context = useContext(DistributorOrderingContext);
  if (!context) {
    throw new Error(
      "useDistributorOrderingCtx must be used within a DistributorOrderingContext"
    );
  }
  return context;
};

export const useOptionalDistributorOrderingCtx = () => {
  return useContext(DistributorOrderingContext);
};
